import { Grid, Dialog, DialogContent } from '@mui/material'
import Questionario from '../questionario/componente/Questionario'
const ModalVisualizaQuestionario = ({
  data,
  openModalQuestionario,
  setOpenModalQuestionario,
}) => {
  const handleFalse = () => {
    setOpenModalQuestionario(false)
  }

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={openModalQuestionario}
      onClose={handleFalse}
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Questionario questionario={data} dsNome={'Nome'} disabled={true} />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalVisualizaQuestionario
